export const filterData=[
    {
        id:'1',
        title:"All"
    },
    {
        id:'2',
        title:"Development"
    },
    {
        id:'3',
        title:"Design"
    },
    {
        id:'4',
        title:"Business"
    },
    {
        id:'5',
        title:"Lifestyle"
    }
];

export const apiUrl="https://codehelp-apis.vercel.app/api/get-top-courses"